//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../media/MediaQuery";

//css
import styled from "styled-components";

// img
import CloseSvg from "../../../assets/img/icon/icon_close.svg";
import PlusSvg from "../../../assets/img/icon/plus.svg";
import TotalSvg from "../../../assets/img/icon/total.svg";

// 임시 이미지
import Product from "../../../assets/img/picture/product_01.jpg";

// responsive
import { M, MMinus, T } from "../../../utils/MT";

// componet
import Pagination from "../../../component/pagination/Pagination";
import BasicBtn from "../../../component/button/BasicBtn";
import CheckBox from "../../../component/button/CheckBox";
import { cartDataList } from "../../../Data";

export default function Cart() {
    //페이지 이동
    const navigate = useNavigate();
    const goProduct = () => {
        navigate(`/product`);
    };
    const goDetailPage = (item) => {
        navigate(`/product/detail/` + item.id);
    };

    const goPay = () => {
        navigate(`/pay`);
    };

    return (
        <Warp>
            <CartTitle>Cart</CartTitle>
            <SimpleCounter>상품목록(3)</SimpleCounter>

            {/* 테이블 ( 페이지네이션 / 상품리스트 / empty 포함 ) */}
            <TableWrap>
                {/* 테이블 타이틀 */}
                <TabelTitle>
                    {/* !!!!!!!!!!!! TableCheck [모바일 + 장바구니가 비었을때] // none 처리 해주세요 !!!!!!!!!!!! */}
                    <TableCheck>
                        <CheckBoxWrap>
                            <CheckBox id="check_all" />
                        </CheckBoxWrap>
                    </TableCheck>

                    <PC>
                        <TableName>상품명</TableName>
                        <TableNum>총수량</TableNum>
                        <TablePrice>판매가</TablePrice>
                        <TableBlock></TableBlock>
                        <TableDelivery>배송비</TableDelivery>
                        <TableDel>삭제</TableDel>
                    </PC>
                </TabelTitle>

                {cartDataList.length > 0 ? (
                    <>
                        {/* 상품 리스트 */}
                        <CartListBigWrap>
                            {cartDataList.map((item, index) => {
                                return (
                                    // 카트 리스트
                                    <CartListBox key={item.id}>
                                        <TableCheck>
                                            <CheckBoxWrap>
                                                <CheckBox id={item.id} />
                                            </CheckBoxWrap>
                                        </TableCheck>

                                        {/* 상품명 */}
                                        <TableItemWrap>
                                            <ImgWrap
                                                onClick={() => {
                                                    goDetailPage(item);
                                                }}
                                            >
                                                <Img src={item.productImg} alt={item.itemName} />
                                            </ImgWrap>
                                            <TextWrap>
                                                <TopWrap>
                                                    <Name
                                                        thinText={item.thinText}
                                                        onClick={() => {
                                                            goDetailPage(item);
                                                        }}
                                                    >
                                                        {item.itemName}
                                                    </Name>
                                                </TopWrap>

                                                <OptionWrap>
                                                    <Option>{item.option}</Option>
                                                </OptionWrap>

                                                {/* MOBILE - 판매가 */}
                                                <Mobile>
                                                    <TablePrice>
                                                        <PriceBigWrap>
                                                            <s>{item.orginPrice}</s>
                                                            <PriceWrap>
                                                                <Price>{item.price}</Price>
                                                                <Won>원</Won>
                                                            </PriceWrap>
                                                        </PriceBigWrap>
                                                    </TablePrice>
                                                </Mobile>
                                            </TextWrap>
                                        </TableItemWrap>

                                        {/* 총 수량 */}
                                        <TableNum>
                                            <CountBtnWrap>
                                                <MinusBtn />
                                                <CountNum type="text" placeholder="1" />
                                                <PlusBtn />
                                            </CountBtnWrap>
                                        </TableNum>

                                        {/* PC - 판매가 */}
                                        <PC>
                                            <TablePrice>
                                                <PriceBigWrap>
                                                    <PriceWrap>
                                                        <Price>{item.price}</Price>
                                                        <Won>원</Won>
                                                    </PriceWrap>
                                                    <s>{item.orginPrice}</s>
                                                </PriceBigWrap>
                                            </TablePrice>
                                        </PC>

                                        <TableBlock></TableBlock>

                                        {/* 배송비 */}
                                        <PC>
                                            <TableDelivery>
                                                <DelText>{item.delivery}</DelText> <DelWon>원</DelWon>
                                            </TableDelivery>
                                        </PC>

                                        {/* 삭제 */}
                                        <TableDel>
                                            <CloseIcon src={CloseSvg} alt="삭제" />
                                        </TableDel>
                                    </CartListBox>
                                );
                            })}
                        </CartListBigWrap>

                        {/* 페이지네이션 */}
                        <PC>
                            {
                                // 3개 이상일시 보이게 해주세요! 모바일은 없음!
                                // cartDataList.length > 3 &&
                                <PageNationWrap>
                                    <Pagination />
                                </PageNationWrap>
                            }
                        </PC>
                    </>
                ) : (
                    <EmptyWrap>
                        <EmptyText>장바구니가 비어있습니다.</EmptyText>
                        <BasicBtn onClick={() => goProduct()} border={true} text="쇼핑하러가기" />
                    </EmptyWrap>
                )}
            </TableWrap>

            {/* 총 금액 box */}
            <PriceBigBigBox>
                <WhiteBox>
                    <Text>총 상품금액</Text>
                    <TotalPriceWrap>
                        <TotalPrice>99,000,000</TotalPrice>
                        <Won mobileBig>원</Won>
                    </TotalPriceWrap>
                </WhiteBox>
                <WhiteBox>
                    <Text>총 배송비</Text>
                    <TotalPriceWrap>
                        <TotalPrice>7,500</TotalPrice>
                        <Won mobileBig>원</Won>
                    </TotalPriceWrap>
                </WhiteBox>
                <WhiteBox>
                    <Text mobileBig>결제 예정 금액</Text>
                    <TotalPriceWrap>
                        <TotalPrice txtcolor>99,007,500</TotalPrice>
                        <Won mobileBig>원</Won>
                    </TotalPriceWrap>
                </WhiteBox>
            </PriceBigBigBox>

            <BtnWrap>
                <BasicBtn
                    onClick={() => {
                        goPay();
                    }}
                    gray={true}
                    text="선택 상품 주문"
                />
                <BasicBtn
                    onClick={() => {
                        goPay();
                    }}
                    text="전체 상품 주문"
                />
            </BtnWrap>
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: calc(100vw * (1280 / 1920));
    margin: 0 auto;

    padding-top: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1130 / 1300));
        padding-top: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(388)};
        padding-top: ${M(30)};
    }
`;
const CartTitle = styled.h3`
    font-family: "Pop-R";
    font-size: calc(100vw * (50 / 1920));
    text-align: center;

    margin-bottom: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));
        margin-bottom: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-bottom: ${M(20)};
    }
`;

const SimpleCounter = styled.p`
    font-size: calc(100vw * (17 / 1920));

    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (17 / 1300));

        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(16)};

        margin-bottom: ${M(10)};
    }
`;

const TableWrap = styled.div``;

const TabelTitle = styled.div`
    display: flex;
    align-items: center;

    padding: calc(100vw * (15 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (15 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)} ${M(5)} ${M(10)};

        border-bottom: none;
    }
`;

const TableCheck = styled.div`
    flex-shrink: 0;
    font-size: calc(100vw * (15 / 1920));
    text-align: center;

    width: calc(100vw * (70 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        width: calc(100vw * (70 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        width: 100%;
    }
`;

const TableItemWrap = styled.div`
    display: flex;
    align-items: center;

    & > div {
        flex-shrink: 0;
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        margin-top: ${M(20)};
    }
`;

const TableName = styled(TableCheck)`
    width: calc(100vw * (440 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (440 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;

const ImgWrap = styled.div`
    flex-shrink: 0;
    width: calc(100vw * (145 / 1920));
    height: calc(100vw * (145 / 1920));

    margin-right: calc(100vw * (30 / 1920));
    margin-bottom: 0;

    cursor: pointer;

    border-radius: 4px;
    border: solid 1px #ddd;
    background-color: #fafafa;

    overflow: hidden;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (145 / 1300));
        height: calc(100vw * (145 / 1300));

        margin-right: calc(100vw * (30 / 1300));
        margin-bottom: 0;
    }

    @media screen and (max-width: 900px) {
        width: ${M(95)};
        height: ${M(95)};
        margin-right: ${M(15)};
        margin-bottom: 0;
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const TextWrap = styled.div`
    width: calc(100vw * (265 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (265 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${MMinus(110)};
    }
`;

const TopWrap = styled.div`
    display: flex;
    align-items: center;

    padding-right: calc(100vw * (1 / 1920));

    @media screen and (max-width: 1300px) {
        padding-right: calc(100vw * (1 / 1300));
    }
`;

const Name = styled.h3`
    font-family: "Pop-EB";
    font-size: calc(100vw * (14 / 1920));

    margin-bottom: calc(100vw * (6 / 1920));

    /* 한줄처리 */
    max-width: calc(100% - calc(100vw * (20 / 1920)));
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-right: auto;
    cursor: pointer;

    ${({ thinText }) => {
        return (
            thinText &&
            `
            font-family: 'Pop-M';
        `
        );
    }}

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));

        margin-bottom: calc(100vw * (6 / 1300));

        /* 한줄처리 */
        max-width: calc(100% - calc(100vw * (20 / 1300)));
    }

    @media screen and (max-width: 900px) {
        font-family: "Pop-M";
        font-size: ${M(14)};
        line-height: 1;
        margin-bottom: ${M(5)};
        max-width: 100%;
    }
`;
const OptionWrap = styled.div`
    & p {
        text-align: left;
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(10)};
    }
`;
const Option = styled.p`
    font-family: "Pop-M";
    font-size: calc(100vw * (13 / 1920));
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const TableNum = styled(TableCheck)`
    width: calc(100vw * (150 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (150 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;

        margin-top: ${M(15)};
    }
`;

const TablePrice = styled(TableCheck)`
    width: calc(100vw * (170 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (170 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
    }
`;

const TableBlock = styled(TableCheck)`
    width: calc(100vw * (150 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (150 / 1300));
        display: none;
    }

    @media screen and (max-width: 900px) {
    }
`;

const TableDelivery = styled(TableCheck)`
    width: calc(100vw * (150 / 1920));

    display: flex;
    align-items: baseline;
    justify-content: center;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (150 / 1300));
    }
`;

const TableDel = styled(TableCheck)`
    width: calc(100vw * (150 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (150 / 1300));
    }

    @media screen and (max-width: 900px) {
        position: absolute;
        top: ${M(10)};
        right: ${M(5)};

        display: flex;

        width: auto;
    }
`;

const CheckBoxWrap = styled.div`
    width: calc(100vw * (20 / 1920));
    height: calc(100vw * (20 / 1920));

    margin: 0 auto;

    & span {
        margin-right: 0;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (20 / 1300));
        height: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};

        margin: 0;
    }
`;

const PriceBigWrap = styled.div`
    text-align: center;

    & s {
        font-family: "Noto-R";
        font-size: calc(100vw * (13 / 1920));
        color: #ccc;

        word-break: break-all;
    }

    @media screen and (max-width: 1300px) {
        & s {
            font-size: calc(100vw * (13 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        text-align: left;

        & s {
            font-size: ${M(13)};
        }
    }
`;
const PriceWrap = styled.div`
    text-align: center;

    display: flex;
    align-items: baseline;
    justify-content: center;

    margin-bottom: calc(100vw * (4 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (4 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: 0;

        justify-content: left;
    }
`;

const Price = styled.p`
    font-family: "Noto-B";
    font-size: calc(100vw * (15 / 1920));

    word-break: break-all;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }
`;

const Won = styled.span`
    font-family: "Noto-R";
    font-size: calc(100vw * (13 / 1920));

    margin-left: calc(100vw * (2 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));

        margin-left: calc(100vw * (2 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(12)};

        margin-left: ${M(2)};
    }

    ${({ mobileBig }) => {
        return (
            mobileBig &&
            `
                    @media screen and (max-width: 900px) {
                        font-size: ${M(14)};
                    }
                `
        );
    }}
`;

const DelText = styled.span`
    font-family: "Noto-R";
    font-size: calc(100vw * (15 / 1920));
    color: #8c8c8c;

    word-break: break-all;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }
`;

const DelWon = styled(DelText)`
    font-size: calc(100vw * (13 / 1920));

    margin-left: calc(100vw * (2 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));

        margin-left: calc(100vw * (2 / 1300));
    }
`;

const CloseIcon = styled.img`
    width: calc(100vw * (13 / 1920));
    height: calc(100vw * (13 / 1920));

    filter: invert(83%) sepia(0%) saturate(4587%) hue-rotate(89deg) brightness(89%) contrast(70%);

    cursor: pointer;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (13 / 1300));
        height: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-shrink: 0;
        width: ${M(13)};
        height: ${M(13)};
    }
`;

const CartListBigWrap = styled.ul`
    margin-bottom: calc(100vw * (45 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (45 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(50)};

        max-height: ${M(600)};
        overflow-y: auto;
    }
`;

const CartListBox = styled.li`
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    padding: calc(100vw * (20 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;

        padding: ${M(10)} ${M(5)} ${M(20)};
    }
`;

const CountBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    margin-left: auto;

    @media screen and (max-width: 900px) {
        justify-content: right;
    }
`;

const MinusBtn = styled.p`
    position: relative;
    width: calc(100vw * (21 / 1920));
    height: calc(100vw * (21 / 1920));

    border: 1px solid #ddd;

    cursor: pointer;

    &:after {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        width: calc(100vw * (9 / 1920));
        height: 1px;

        background: #222;

        transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (21 / 1300));
        height: calc(100vw * (21 / 1300));

        &:after {
            width: calc(100vw * (9 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(20)};
        height: ${M(20)};

        &:after {
            width: ${M(9)};
        }
    }
`;

const CountNum = styled.input`
    width: calc(100vw * (50 / 1920));
    font-size: calc(100vw * (15 / 1920));
    text-align: center;

    &::placeholder {
        color: #222;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (50 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(48)};
        font-size: ${M(14)};
    }
`;

const PlusBtn = styled(MinusBtn)`
    &:before {
        position: absolute;
        top: 50%;
        left: 50%;
        content: "";
        width: 1px;
        height: calc(100vw * (9 / 1920));

        background: #222;

        transform: translate(-50%, -50%);
    }

    @media screen and (max-width: 1300px) {
        &:before {
            height: calc(100vw * (9 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:before {
            height: ${M(9)};
        }
    }
`;

const EmptyWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: calc(100vw * (200 / 1920));
    margin: calc(100vw * (110 / 1920)) auto;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (200 / 1300));
        margin: calc(100vw * (110 / 1300)) auto;
    }

    @media screen and (max-width: 900px) {
        width: ${M(180)};
        margin: ${M(225)} auto;
    }
`;

const EmptyText = styled.p`
    font-size: calc(100vw * (15 / 1920));
    color: #ddd;

    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(20)};
    }
`;

const PageNationWrap = styled.div`
    text-align: center;

    margin-bottom: calc(100vw * (45 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (45 / 1300));
    }
`;

const PriceBigBigBox = styled.ul`
    display: flex;
    align-items: center;

    width: 100%;

    margin-bottom: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        margin-bottom: ${M(52)};
    }
`;

const WhiteBox = styled.li`
    flex-shrink: 0;
    position: relative;
    width: 33.3333%;

    text-align: center;

    padding: calc(100vw * (83 / 1920)) 0;

    background: #fafafa;

    &:nth-child(2):after,
    &:nth-child(2):before {
        position: absolute;
        top: 50%;
        content: "";

        width: calc(100vw * (22 / 1920));
        height: calc(100vw * (22 / 1920));

        background: no-repeat center center / contain;

        z-index: 3;
    }

    &:nth-child(2):after {
        left: 0;
        background-image: url(${PlusSvg});
        transform: translate(-50%, -50%);
    }

    &:nth-child(2):before {
        right: 0;
        background-image: url(${TotalSvg});
        transform: translate(50%, -50%);
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (83 / 1300)) 0;

        &:nth-child(2):after,
        &:nth-child(2):before {
            width: calc(100vw * (22 / 1300));
            height: calc(100vw * (22 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: left;

        background-color: #fff;

        padding: 0;

        &:nth-child(2) {
            padding: ${M(10)} 0 ${M(18)};
        }

        &:nth-child(2):after,
        &:nth-child(2):before {
            display: none;
        }
    }
`;

const Text = styled.p`
    font-size: calc(100vw * (15 / 1920));
    margin-bottom: calc(100vw * (17 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
        margin-bottom: calc(100vw * (17 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-shrink: 0;
        min-width: ${M(100)};
        font-size: ${M(14)};
        margin-bottom: 0;
    }

    ${({ mobileBig }) => {
        return (
            mobileBig &&
            `
                    @media screen and (max-width: 900px) {
                        font-size: ${M(16)};
                    }
                `
        );
    }}
`;

const TotalPriceWrap = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: center;

    padding: 0 calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        padding: 0 calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: 0;
    }
`;

const TotalPrice = styled.span`
    font-family: "Noto-B";
    font-size: calc(100vw * (20 / 1920));
    word-break: break-all;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
    }

    ${({ txtcolor }) => {
        return (
            txtcolor &&
            `
                color: var(--main-color);

            @media screen and (max-width: 900px) {
                font-size: ${M(20)};
            }
        `
        );
    }}
`;

const BtnWrap = styled.div`
    display: flex;
    justify-content: center;

    margin-bottom: calc(100vw * (200 / 1920));

    & > p {
        width: calc(100vw * (200 / 1920));
    }

    & > p:first-child {
        margin-right: calc(100vw * (19 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (200 / 1300));

        & > p {
            width: calc(100vw * (200 / 1300));
        }

        & > p:first-child {
            margin-right: calc(100vw * (19 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(50)};

        & > p {
            width: ${M(180)};
            /* padding: ${M(9)} 0; */
        }

        & > p:first-child {
            margin-right: ${M(18)};
        }
    }
`;
